import { TriangleAlert } from "lucide-react";
import { formatCriteriaEvaluationErrorMessage } from "../../../../utils/criteriaEvaluationModal";
import CriteriaEvaluationStateGraphic from "./CriteriaEvaluationStateGraphic";

/** Props for the failed criteria-evaluation panel. */
export interface CriteriaEvaluationErrorProps {
  error: string;
  onRetry: () => void;
}

/**
 * Full-panel failure state shown when criteria analysis could not be queued.
 *
 * @param props - Failure message and retry callback
 * @returns Criteria-evaluation error screen
 */
export function CriteriaEvaluationError({
  error,
  onRetry,
}: CriteriaEvaluationErrorProps) {
  return (
    <div
      className="flex h-full min-h-0 items-center justify-center bg-white"
      role="alert"
    >
      <div className="flex flex-col items-center text-center">
        <CriteriaEvaluationStateGraphic>
          <TriangleAlert aria-hidden="true" color="#CC0300" size={42} />
        </CriteriaEvaluationStateGraphic>
        <h2 className="mb-2 text-base font-bold text-primaryGray-2">
          Unable to complete Criteria Evaluation
        </h2>
        <p className="m-0 text-base leading-7 text-primaryGray-3">
          {formatCriteriaEvaluationErrorMessage(error)}
        </p>
        <button
          type="button"
          className="mt-6 rounded bg-primaryGray-1 px-5 py-3 text-base font-semibold text-white transition-opacity hover:opacity-90"
          onClick={onRetry}
        >
          Re-Initiate Evaluation
        </button>
      </div>
    </div>
  );
}

export default CriteriaEvaluationError;
